var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header",style:(_vm.overrideHeaderStyle)},[_c('h1',{style:(_vm.overrideHeaderTitleStyle)},[_vm._t("default")],2),_c('CloseButton',{staticClass:"close-button",on:{"clicked":_vm.onCloseClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }